import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoPrev = () => {
  return (
    <g>
      <path d="M14.266 0a.758.758 0 0 0-.38.102L1.352 7.398a.688.688 0 0 0 0 1.204l12.532 7.296a.752.752 0 0 0 1.008-.237.682.682 0 0 0 .107-.365V.704C15 .315 14.671 0 14.266 0zM13.5 2.062v11.875L3.301 7.999 13.5 2.062z" />
    </g>
  );
};

export default withIcon(IconVideoPrev);
